module.exports = __webpack_public_path__ + "img/uptime.ec168e4.svg";